const getBrowserInfo = () => {
  // First try using User Agent Client Hints API if available
  if ((navigator as any)?.userAgentData) {
    return {
      browser: (navigator as any)?.userAgentData?.brands[0]?.brand,
      version: (navigator as any)?.userAgentData?.brands[0]?.version,
      platform: (navigator as any)?.userAgentData?.platform,
      mobile: (navigator as any)?.userAgentData?.mobile,
    };
  }

  // Fallback to traditional userAgent string parsing
  const userAgent = navigator.userAgent;
  let browser = "Unknown";
  let version = "Unknown";
  let matched;

  // Chrome
  if ((matched = userAgent.match(/(chrome(?=\/))\/?\s*(\d+)/i))) {
    browser = "Chrome";
    version = matched[2];
  }
  // Firefox
  else if ((matched = userAgent.match(/(firefox(?=\/))\/?\s*(\d+)/i))) {
    browser = "Firefox";
    version = matched[2];
  }
  // Safari
  else if ((matched = userAgent.match(/version\/(\d+).+?safari/i))) {
    browser = "Safari";
    version = matched[1];
  }
  // Edge (Chromium-based)
  else if ((matched = userAgent.match(/edg\/(\d+)/i))) {
    browser = "Edge";
    version = matched[1];
  }
  // IE
  else if ((matched = userAgent.match(/(trident).+rv[:\s]([\d]+)/i))) {
    browser = "Internet Explorer";
    version = matched[2];
  }

  const isMobileBrowser = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };

  return {
    browser: browser,
    version: version,
    userAgent: userAgent,
    platform: navigator.platform,
    language: navigator.language,
    cookiesEnabled: navigator.cookieEnabled,
    isOnline: navigator.onLine,
    isMobile: isMobileBrowser(),
  };
};

export const getContext = () => {
  const userAgent = navigator.userAgent;
  const locale = navigator.language || (navigator as any).userLanguage;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const page = {
    path: window.location.pathname,
    url: window.location.href,
  };

  const browserInfo = getBrowserInfo();

  return { page, userAgent, locale, timezone, browserInfo };
};
